import { axios } from '^/axios';

export const fetchSubscriptions = ({ regionUuid, vendorUuid }) => {
  return axios.get(
    `/region/${regionUuid}/vendor/${vendorUuid}/rotating-subscriptions`
  );
};

export const fetchRotatingSubscriptionProducts = ({
  rotationUuid,
  timestamp = null,
  availableAt = null,
}) => {
  let url = `/rotating-subscription/${rotationUuid}/products`;
  const params = {};

  if (timestamp) {
    params.timestamp = timestamp;
  }

  if (availableAt) {
    params.available_at = availableAt;
  }

  if (Object.keys(params).length > 0) {
    url += '?' + new URLSearchParams(params).toString();
  }

  return axios.get(url);
};

export const getSubscriptionById = (subscribtion_id) => {
  return axios.get(`/subscriptions/${subscribtion_id}`);
};

export const getAllSkipDeliverySlots = (subscribtion_uuid) => {
  return axios.get(`/subscription/${subscribtion_uuid}/all-slots`);
};

export const getSkipDeliverySlots = (subscribtion_uuid) => {
  return axios.get(`/subscription/${subscribtion_uuid}/skipped-slots`);
};

export const submitSkippedSlot = (subscriptionId, slotDate) => {
  return axios.post(`/subscription/${subscriptionId}/slot`, {
    slot: slotDate,
  });
};

export const deleteSkippedSlot = (subscriptionId, slotDate) => {
  return axios.delete(`/subscription/${subscriptionId}/slot`, {
    params: {
      slot: slotDate,
    },
  });
};

export const customerSubscriptionProductSelection = ({ data }) => {
  return axios.post('/customer-subscription-product-selection', data);
};

export const getCustomerSubscriptionProductSelection = ({
  rotationUuid,
  scheduled,
}) => {
  return axios.get(`/customer-subscription-product-selection/${rotationUuid}`, {
    params: {
      scheduled: scheduled,
    },
  });
};

// New shared utility functions for rotating subscriptions
export const formatSubscriptionProducts = (
  products,
  currentlySelectedProducts = []
) => {
  return products.map((product) => {
    const selectedProduct = currentlySelectedProducts?.find(
      (p) => p.id === product.id
    );
    return {
      ...product,
      price:
        selectedProduct?.price ||
        parseFloat(product.product.price_with_defaults).toFixed(2),
      product: {
        ...product.product,
        quantity: selectedProduct?.quantity || 0,
        modifiers: selectedProduct?.modifiers || [],
        ingredients: selectedProduct?.ingredients || [],
        recipes: selectedProduct?.recipes || [],
      },
      favorite: selectedProduct?.favorite || false,
    };
  });
};

export const calculateMealsSelected = (selectedProducts) => {
  return Object.values(selectedProducts).reduce((acc, item) => {
    return acc + (item.quantity || 0);
  }, 0);
};

export const validateRotatingSubscriptionOrder = (
  mealsSelected,
  minItems,
  maxItems
) => {
  return mealsSelected >= minItems && mealsSelected <= maxItems;
};

export const calculatePrice = (subscription, selectedProducts, daysOfWeek) => {
  let subtotal = 0.0;

  if (subscription.use_product_prices) {
    subtotal = Object.values(selectedProducts).reduce((totalPrice, product) => {
      return totalPrice + parseFloat(product.price) * (product.quantity || 0);
    }, 0.0);
  } else if (subscription.pricing_model === 'PER_MEAL') {
    subtotal = Object.values(selectedProducts).reduce((totalPrice, product) => {
      return totalPrice + parseFloat(product.price) * (product.quantity || 0);
    }, 0.0);
  } else if (subscription.pricing_model === 'PER_TIMESLOT') {
    subtotal = daysOfWeek.reduce((totalPrice, day) => {
      return (
        totalPrice +
        (subscription.subscription && subscription.subscription[day]
          ? subscription.price_override
          : 0)
      );
    }, 0.0);
  }

  return Math.max(subtotal).toFixed(2);
};

export const hasMealSelectionForWeek = (subscriptionId, scheduledDate) => {
  return axios.get(`/subscription/${subscriptionId}/has-meal-selection`, {
    params: {
      scheduled: scheduledDate,
    },
  });
};
